import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderAddRight"><Path d="M10.4014 3H2V20H12.8027C12.2922 19.1175 12 18.0929 12 17C12 13.6863 14.6863 11 18 11C19.5367 11 20.9385 11.5777 22 12.5278V6H12.4014L10.4014 3Z" fill="currentColor"/><Path d="M18.75 13H17.25V16.25H14V17.75H17.25V21H18.75V17.75H22V16.25H18.75V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderAddRight;
